import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ControlsModule } from "src/app/controls/controls.module";
import { LearnViewComponent } from "./learn-view.component";
import { CoreModule } from "src/app/core/core.module";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "src/app/shared/shared.module";
import { TablerIconComponent } from "angular-tabler-icons";
import { LearnSuccessViewComponent } from "./learn-success-screen/learn-success-view.component";
import { LearnIntroComponent } from "./learn-intro/learn-intro.component";

@NgModule({
  declarations: [
    LearnViewComponent,
    LearnSuccessViewComponent,
    LearnIntroComponent
  ],
  imports: [
    CommonModule,
    ControlsModule,
    SharedModule,
    CoreModule,
    TranslateModule,
    TablerIconComponent
],
  exports: [
    LearnViewComponent,
    LearnSuccessViewComponent,
    LearnIntroComponent
  ]
})
export class LearnViewModule { }